export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6888.b6e5db03.jpg";